import Layout from '@/components/feature/Layout';
import useSeo from '@/hooks/useSeo';
import { comics } from '@/mocks/comics';
import Hero from './components/Hero';
import RankingPreview from './components/RankingPreview';
import Genres from './components/Genres';
import EditorPicks from './components/EditorPicks';
import MustRead from './components/MustRead';
import FaqTeaser from './components/FaqTeaser';

const siteBase = (window as unknown as { __BASE_PATH__?: string }).__BASE_PATH__ ?? '';
const siteUrl = typeof window !== 'undefined' ? `${window.location.origin}${siteBase}` : '';

export default function Home() {
  useSeo({
    title: '好看的韩国漫画排行榜·评分高·人气榜必看榜一站看 - 韩漫精选榜',
    description:
      '韩国漫画排行榜实时更新，聚合人气榜、必看榜与评分高作品。想看十大推荐或热门排行，点开即得高分韩漫清单，按热度排序快速找到当下最值得追的韩国漫画。',
    keywords:
      '好看的韩国漫画,好看的韩国漫画排行榜,好看的韩国漫画人气榜,好看的韩国漫画十大推荐,好看的韩国漫画评分高,好看的韩国漫画热门排行,好看的韩国漫画必看榜',
    canonicalPath: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '韩漫精选榜',
        url: siteUrl,
        description: '好看的韩国漫画排行榜，聚合人气榜、评分榜与必看榜，实时更新高分韩漫清单。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/ranking/popularity?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '好看的韩国漫画排行榜',
        itemListElement: comics.slice(0, 8).map((c, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: c.title,
          url: `${siteUrl}/comic/${c.id}`,
        })),
      },
    ],
  });

  return (
    <Layout>
      <Hero />
      <RankingPreview type="popularity" />
      <Genres />
      <RankingPreview type="rating" accent />
      <EditorPicks />
      <MustRead />
      <FaqTeaser />
    </Layout>
  );
}